import { Alert, Box, Button } from '@mui/material';
import React from 'react';
import { Breadcrumb } from 'src/components/Breadcrumb';
import GridData from 'src/components/GridData/GridData';
import PrivateLayoutView from 'src/Layout/PrivateLayout/PrivateLayoutView';
import { mutedGridRowClassName } from 'src/UIKit';
import { useContactCaptureListController } from '../../controllers';
import { CONTACT_CAPTURE_PAGE_SIZE } from '../../helpers';
import { ContactCaptureEmptyState } from './ContactCaptureEmptyState';
import { ContactCaptureListDialogs } from './ContactCaptureListDialogs';
import { ContactCaptureListHeader } from './ContactCaptureListHeader';
import { ContactCaptureRowActions } from './ContactCaptureRowActions';
import { CONTACT_CAPTURE_LIST_COLUMNS } from './contactCaptureListColumns';
import { useContactCaptureListActions } from './useContactCaptureListActions';

export const ContactCaptureListView = () => {
  const controller = useContactCaptureListController();
  const actions = useContactCaptureListActions(controller);
  const visibleRows = controller.listCompanyId === controller.companyId
    ? controller.list?.items || []
    : [];

  return (
    <>
      <PrivateLayoutView
        title={(
          <Box>
            <Breadcrumb items={[{ label: 'Contact Capture', isActive: true }]} />
          </Box>
        )}
      >
        {controller.error ? (
          <Alert
            severity="error"
            action={(
              <Button
                color="inherit"
                size="small"
                onClick={() => void controller.reload().catch(() => undefined)}
              >
                Retry
              </Button>
            )}
            sx={{ alignItems: 'center' }}
          >
            {controller.error}
          </Alert>
        ) : (
          <GridData
            header={<ContactCaptureListHeader {...controller} />}
            isLoading={controller.loading.list}
            rows={visibleRows}
            columns={CONTACT_CAPTURE_LIST_COLUMNS}
            renderAction={record => (
              <ContactCaptureRowActions
                mutationLoading={controller.loading.mutation}
                record={record}
                onDuplicate={value => void actions.duplicate(value)}
                onPreview={value => void actions.preview(value)}
                onStatusChange={actions.changeStatus}
              />
            )}
            getRowClassName={params =>
              params.row.status === 'inactive' ? mutedGridRowClassName : ''
            }
            noRowsOverlay={ContactCaptureEmptyState}
            sorting={{ value: controller.filter.sort, onChange: controller.changeSorting }}
            pagination={{
              page: controller.filter.page,
              pageSize: controller.filter.limit || CONTACT_CAPTURE_PAGE_SIZE,
              totalCount: controller.listCompanyId === controller.companyId
                ? controller.list?.count
                : 0,
              onChange: controller.changePagination,
            }}
            sx={{
              minWidth: 0,
              '& .MuiDataGrid-cell': { display: 'flex', alignItems: 'center' },
              '& .MuiDataGrid-cell[data-field="name"] > *, & .MuiDataGrid-cell[data-field="campaign"] > *': {
                width: '100%',
              },
            }}
          />
        )}
      </PrivateLayoutView>
      <ContactCaptureListDialogs
        confirm={actions.confirm}
        onCloseConfirmation={() => actions.setConfirm(null)}
      />
    </>
  );
};

export default ContactCaptureListView;
